export default "__VITE_ASSET__c8e2a045__"